var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilLineEmail = function SvgPencilLineEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.2 7.715-7.135 6.39L4.8 7.695V18.3h8.1v1.8h-9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9v6h-1.8zM18.75 5.7H5.26l6.795 5.996zm.243 8.286 1.719 1.719-4.011 4.01h-1.72v-1.719zm.573-.573.86-.86a.405.405 0 0 1 .572 0l1.146 1.146a.405.405 0 0 1 0 .573l-.86.86z"
  })));
};
export default SvgPencilLineEmail;